var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-repeat=\"doc in $ctrl.popoverDocuments.content\">\n<a ng-href=\"{{doc.url}}\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> {{doc.name}}</a>\n</div>\n";
var id1="app/_directives/popoverDocumentsTemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;